import moment from "moment";

export default function CreateDomesticFieldReactiveWorkItemModel(mergedData) {
  return {
    workorderid: mergedData.id,
    workordername: `${mergedData.categoryName} at ${mergedData.siteName}`,
    workordercategoryid: mergedData.category,
    workordercategoryname: mergedData.categoryName,
    workordersubcategoryid: mergedData.subCategory,
    workordersubcategoryname: mergedData.subCategoryName,
    reportername: mergedData.reportername,
    reportertype: mergedData.reportertype,
    siteid: mergedData.siteId,
    sitename: mergedData.siteName,
    propertyid: mergedData.propertyId,
    propertyname: mergedData.propertyName,
    propertynumber: mergedData.propertyNumber,
    territoryid: mergedData.territoryId,
    territoryname: mergedData.territoryName,
    customerresidentname: mergedData.customername,
    customercontactnumber: mergedData.customerphone,
    sla: mergedData.slahours,
    description: mergedData.faultDescription,

    identityconfirmationcode: "", // Always empty
    customervulnerability: mergedData.customervulnerability,

    diagnosis: mergedData.diagnosis,
    customerid: mergedData.customerId,
    customername: mergedData.clientName,

    workitemtemplateid: mergedData.workitemtemplateid,
    workitemtemplateref: mergedData.workitemtemplateref,
    preferredappointmentdate:
      moment(mergedData.preferredAppointmentDate).toISOString() || "",
    preferredappointmenttimeslot: mergedData.preferredAppointmentSlot,
    preferredappointmenttimeslottitle: mergedData.preferredAppointmentSlotTitle,
    workitemagreement: mergedData.appointmentConfirmed,
    workitemagreementtitle: mergedData.appointmentConfirmedTitle,
    workitemcategoryid: mergedData.workitemcategoryid,
    workitemcategoryname: mergedData.workitemcategoryname,
    jobspecificaccessnotes: mergedData.jobSpecificAccessNotes,
    propertyaccessnotes: mergedData.propertyaccessnotes,
    redflag: mergedData.redflag,
    idempotencyGuid: mergedData.idempotencyGuid,
    workitemnotes: mergedData.workItemNotes,
    expectedparts: mergedData.expectedParts,
    faultyassets: mergedData.faultyAssets,
    createdBy: mergedData.createdBy,
    noAccessattempts: mergedData.noAccessAttempts,
  };
}
